var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.927,
    height: 32.829,
    viewBox: "0 0 30.927 32.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9.882H2.209A13,13,0,0,1,6.721,0,12.758,12.758,0,0,0,0,11.354H23.562a13.77,13.77,0,0,0-.089-1.473Z",
    transform: "translate(3.713 6.833)",
    fill: "#d84a4a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.226,13.99a.663.663,0,0,1-.663-.663c0-6.618-4.988-12-11.119-12S1.325,6.71,1.325,13.328a.663.663,0,0,1-1.325,0C0,5.979,5.582,0,12.444,0S24.888,5.979,24.888,13.328A.663.663,0,0,1,24.226,13.99Z",
    transform: "translate(3.049 4.946)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.081,3.534a.663.663,0,0,1-.663-.663,1.546,1.546,0,0,0-3.093,0A.663.663,0,0,1,0,2.872a2.872,2.872,0,1,1,5.743,0A.663.663,0,0,1,5.081,3.534Z",
    transform: "translate(12.622 2.59)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.664,6A.663.663,0,0,1,0,5.266,6.606,6.606,0,0,1,3.378.081a.663.663,0,1,1,.63,1.166A5.283,5.283,0,0,0,1.322,5.4.663.663,0,0,1,.664,6Z",
    transform: "translate(7.147 10.109)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.632,14.64V3.716a2.43,2.43,0,0,1,2.046-2.39H.662A.663.663,0,0,1,.662,0h29.6a.663.663,0,1,1,0,1.326H26.349a1.359,1.359,0,0,1,.2,2l-9.4,11.632a.663.663,0,0,1-1.031-.833L25.528,2.475a.413.413,0,0,1,.032-.037.028.028,0,0,0,.008-.032.036.036,0,0,0-.028-.027L25,2.224a2.562,2.562,0,0,0-2.515.638.448.448,0,0,1-.049.044l-8.41,6.826-.073.064a3.141,3.141,0,0,1-3.212.613A2.328,2.328,0,0,1,9.179,8.094V3.716a1.111,1.111,0,0,0-2.221,0V14.64a.663.663,0,1,1-1.326,0Z",
    transform: "translate(0.03 17.525)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,.663v2.43a.663.663,0,0,0,1.325,0V.663A.663.663,0,1,0,0,.663Z",
    transform: "translate(20.28 0.147)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,.663V3.9a.663.663,0,0,0,1.325,0V.663A.663.663,0,1,0,0,.663Z",
    transform: "translate(8.646)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,.663V4.492a.663.663,0,0,0,1.325,0V.663A.663.663,0,1,0,0,.663Z",
    transform: "translate(4.596 2.577)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,.663V4.271a.663.663,0,0,0,1.325,0V.663A.663.663,0,1,0,0,.663Z",
    transform: "translate(24.33 2.283)",
    fill: "#d84a4a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMain);
export default __webpack_public_path__ + "static/media/ic_main.4fcfa5fe9df45b4fb143001c52f7e332.svg";
export { ForwardRef as ReactComponent };